import { joinPath } from '@eb/path-utils';

import {
    BASE_URL,
    ADMIN_ORGANIZATIONS_BASE_URL,
    ADMIN_PERMISSIONS_BASE_URL,
} from './constants';

export const getFullOrganizationsUrl = (subPath = '', isStaffPermissions) => {
    const baseUrl = isStaffPermissions ? ADMIN_PERMISSIONS_BASE_URL : BASE_URL;

    return joinPath(baseUrl, subPath);
};

export const getFullAdminOrganizationsUrl = (subPath = '') =>
    joinPath(ADMIN_ORGANIZATIONS_BASE_URL, subPath);
